var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-style',[_vm._v(" .hamburger-bars { color: "+_vm._s(_vm.hamburgerColor)+"; } ")])}
var staticRenderFns = []

export { render, staticRenderFns }